




































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import DatePicker from "vue2-datepicker";
import VueTimepicker from "vue2-timepicker";

import { IPushMessage } from "@/@types/speciaMessage/speciaMessage";
import { ILocale } from "@/@types/locale";

import "vue2-datepicker/locale/ru";
import "vue2-datepicker/locale/en";

interface ITimepicker {
  HH: string;
  mm: string;
}

@Component({
  components: { submit: SubmitResetButtonGroop, DatePicker, VueTimepicker },
})
export default class MessagePushForm extends Vue {
  @Prop({ type: String, default: "" }) locale!: string;
  @Prop({ type: String, default: "" }) manager_id!: string;

  message = "";
  messages: ILocale = {};
  date: string | Date | null = null;
  time: ITimepicker | null = null;
  now = false;

  get push(): IPushMessage {
    return {
      value: this.messages,
      date: !this.now && this.date ? this.date : "now",
      manager_id: this.manager_id,
      variant: "info",
    };
  }

  @Watch("message")
  updateName(): void {
    this.messages[this.locale] = this.message;
  }

  @Watch("locale")
  changeItemParams(): void {
    if (this.messages)
      this.message = this.messages[this.locale]
        ? this.messages[this.locale]
        : "";
    else this.message = "";
  }

  @Watch("time", { deep: true })
  updateDateTime(): void {
    console.log("updateDateTime");

    if (!this.date || !this.time) return;
    const date = new Date(this.date);
    date.setMinutes(Number(this.time.mm));
    date.setHours(Number(this.time.HH));

    this.date = date;
  }

  sendNow(): void {
    this.now = true;
    this.date = new Date();
    if (!this.date) return;
    const minutes = this.date.getMinutes();
    this.time = {
      HH: String(this.date.getHours()),
      mm: String(minutes < 10 ? `0${minutes}` : minutes),
    };
  }

  onSubmit(event: Event): void {
    event.preventDefault();

    this.$emit("send", { push: this.push });
  }

  onReset(): void {
    this.message = "";
    this.messages = {};
    this.date = null;
    this.date = null;
    this.time = null;
  }
}
